/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ShoppingCartPreOrderBookListBookItemDto from './ShoppingCartPreOrderBookListBookItemDto';

/**
 * The ShoppingCartPreOrderBookListDto model module.
 * @module model/ShoppingCartPreOrderBookListDto
 * @version v1.0.0
 */
class ShoppingCartPreOrderBookListDto {
    /**
     * Constructs a new <code>ShoppingCartPreOrderBookListDto</code>.
     * @alias module:model/ShoppingCartPreOrderBookListDto
     */
    constructor() { 
        
        ShoppingCartPreOrderBookListDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShoppingCartPreOrderBookListDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShoppingCartPreOrderBookListDto} obj Optional instance to populate.
     * @return {module:model/ShoppingCartPreOrderBookListDto} The populated <code>ShoppingCartPreOrderBookListDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShoppingCartPreOrderBookListDto();

            if (data.hasOwnProperty('bookListName')) {
                obj['bookListName'] = ApiClient.convertToType(data['bookListName'], 'String');
            }
            if (data.hasOwnProperty('books')) {
                obj['books'] = ApiClient.convertToType(data['books'], [ShoppingCartPreOrderBookListBookItemDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {String} bookListName
 */
ShoppingCartPreOrderBookListDto.prototype['bookListName'] = undefined;

/**
 * @member {Array.<module:model/ShoppingCartPreOrderBookListBookItemDto>} books
 */
ShoppingCartPreOrderBookListDto.prototype['books'] = undefined;






export default ShoppingCartPreOrderBookListDto;

